import type { Settings } from '~/types/cms'

export const DEFAULT_SETTINGS: Settings = {
  fallbackForms: false,
  maintenanceMode: false,
  maintenanceMessage: undefined,
}

export const cmsSettings = async (): Promise<{ success: boolean; settings: Settings }> => {
  const { $contentfulClient } = useNuxtApp()
  // TODO: Fix typing
  // @ts-ignore
  const res = await $contentfulClient.getEntries({
    content_type: 'settings',
    limit: 1,
  })

  return res?.items?.[0]?.fields
    ? { success: true, settings: res?.items?.[0]?.fields as unknown as Settings }
    : { success: false, settings: DEFAULT_SETTINGS }
}
